import React from "react";
import { Button } from "./ui/button";

export const CallToAction = () => {
  return (
    <section
      id="pide-ya"
      className="py-16 bg-gradient-to-br from-salbox-primary/90 via-salbox-primary to-salbox-primary-600/80 scroll-mt-20"
    >
      <div className="container mx-auto px-4">
        <div className="text-center text-white">
          <h2 className="text-4xl font-lufga-semibold mb-6 uppercase">
            ¿Tienes hambre?
          </h2>
          <p className="text-xl font-lufga mb-8 max-w-2xl mx-auto opacity-90">
            Descarga nuestra app y disfruta de la mejor comida en la comodidad
            de tu hogar. ¡Entrega rápida y calidad garantizada!
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button
              size="lg"
              className="bg-salbox-secondary hover:bg-salbox-secondary-600 text-white font-lufga-semibold px-8 py-4 text-lg"
              onClick={() => window.open("#", "_blank")}
            >
              <svg
                className="w-6 h-6 mr-2"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
              </svg>
              Descargar para iOS
            </Button>

            <Button
              size="lg"
              className="bg-white hover:bg-salbox-neutral-100 text-salbox-primary font-lufga-semibold px-8 py-4 text-lg"
              onClick={() => window.open("#", "_blank")}
            >
              <svg
                className="w-6 h-6 mr-2"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
              </svg>
              Descargar para Android
            </Button>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-3xl font-lufga-semibold mb-2">1000+</div>
              <div className="font-lufga opacity-90">Clientes satisfechos</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-lufga-semibold mb-2">4.9★</div>
              <div className="font-lufga opacity-90">Calificación promedio</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
